import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Select, { MultiValue } from 'react-select'
import { useGame } from "../contexts/GameContext";
import illustration from '../assets/ilustracao.png';

export const Intro = () => {
    const navigate = useNavigate();

    const [group, setGroup] = useState(['all']);
    const [grade, setGrade] = useState(['all']);
    const [random, setRandom] = useState(false);

    const { availableGroups, availableGrades, selectQuizz } = useGame();

    const groups = availableGroups.map(g => ({ value: g, label: g}));
    const grades = availableGrades.map(g => ({ value: g, label: g}));

    function handleStart() {        
        selectQuizz(group, grade, random)
        navigate(`/quizz`);
    }

    function handleGroupChange(item: MultiValue<{ value: string, label: string }>) {
        if (item.length === 0) {
            setGroup(['all']);
            return;
        }
        setGroup(item.map((opt: any) => opt.value));
    }

    function handleGradeChange(item: MultiValue<{ value: string, label: string }>) {
        if (item.length === 0) {
            setGrade(['all']);
            return;
        }
        setGrade(item.map((opt: any) => opt.value))
    }

    return (
        <div className="intro">
            <header>
                <h1>Feira dos Desafios</h1>
                <img src={illustration} alt="Feira dos desafios" width="100%" />
                <h2>Faz um jogo à tua medida</h2>
            </header>

            <Select options={groups} isMulti placeholder="Escolhe um ou mais temas" onChange={handleGroupChange} />            
            <Select options={grades} isMulti placeholder="Escolhe um ou mais anos de escolaridade" onChange={handleGradeChange} />            

            <label htmlFor="random">
                <input type="checkbox" id="random" checked={random} onChange={() => setRandom(!random)} title="Perguntas aleatórias" />
                Limita o teu jogo a 15 questões aleatórias
            </label>

            <button className="btn" onClick={handleStart}>Iniciar</button>
        </div>
    );
}